import { Check, Palette } from 'lucide-react'
import { useThemeStore, THEME_ACCENTS, type ThemeMode } from '../../stores/theme'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '../ui/DropdownMenu'
import { IconButton } from '../ui/IconButton'
import { cn } from '../../lib/utils'

const MODES: { value: ThemeMode; label: string }[] = [
  { value: 'dark', label: 'Dark' },
  { value: 'light', label: 'Light' },
  { value: 'system', label: 'System' },
]

export function ThemeSwitcher() {
  const theme = useThemeStore((s) => s.theme)
  const accent = useThemeStore((s) => s.accent)
  const setTheme = useThemeStore((s) => s.setTheme)
  const setAccent = useThemeStore((s) => s.setAccent)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton aria-label="Change theme" title="Change theme">
          <Palette />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Appearance</DropdownMenuLabel>
        {MODES.map((mode) => (
          <DropdownMenuItem key={mode.value} onClick={() => setTheme(mode.value)}>
            <Check
              className={cn('h-4 w-4', theme === mode.value ? 'opacity-100' : 'opacity-0')}
            />
            {mode.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Accent</DropdownMenuLabel>
        {THEME_ACCENTS.map((item) => (
          <DropdownMenuItem key={item.value} onClick={() => setAccent(item.value)}>
            <Check
              className={cn('h-4 w-4', accent === item.value ? 'opacity-100' : 'opacity-0')}
            />
            <span
              aria-hidden="true"
              className="h-4 w-4 rounded-full border border-border"
              style={{ backgroundColor: item.dot }}
            />
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
